import { produce } from 'immer';
import { AnyAction } from 'redux';

import { GET_SERVICE_SUCCESS } from '../constants';

const initState = {};

const orderReducer = produce((draft = initState, action: AnyAction) => {
  switch (action.type) {
    case GET_SERVICE_SUCCESS:
      draft.service = action.payload;
      break;
    default:
      return draft;
  }
});

export default orderReducer;
